import moment from "moment";

export default class Company {
	constructor({
		name,
		address,
		phone,
		nit,
		date_init,
		date_end,
		contac_persons,
		department,
		city,
		country,
		description,
		id,
		realtionship_vp,
	}) {
		this.id = id || 0;
		this.name = name || "";
		this.address = address || "";
		this.phone = phone || "";
		this.nit = nit || "";
		this.date_init = date_init !== undefined ? moment(date_init).format() : new Date();
		this.date_end = date_end !== undefined ? moment(date_end).format() : new Date();
		this.contac_persons = contac_persons || "";
		this.department = department || "";
		this.city = city || "";
		this.country = country || "";
		this.description = description || "";
		this.realtionship_vp = realtionship_vp || "all";
	}
	validateCompany() {
		let valid = true;
		let invalidFields = [];
		for (const key in this) {
			if (Object.hasOwnProperty.call(this, key)) {
				const element = this[key];
				if (typeof element === "string" && element === "") {
					invalidFields.push(`CompanyForm.${key}Required`);
					valid = false;
				}
			}
		}
		if (!this.validateDates()) {
			invalidFields.push(`CompanyForm.DateInitError`);
			valid = false;
		}
		return {valid, invalidFields};
	}
	validateDates() {
		return new Date(this.date_init).getTime() <= new Date(this.date_end).getTime();
	}
}
